var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidPasswordCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24024 14.5041C8.11024 14.5041 7.98023 14.4541 7.89023 14.3541L3.39023 9.85414C3.19023 9.65414 3.19023 9.34414 3.39023 9.14414C3.59023 8.94414 3.90024 8.94414 4.10024 9.14414L8.25024 13.2941L15.9002 5.64414C16.1002 5.44414 16.4102 5.44414 16.6102 5.64414C16.8102 5.84414 16.8102 6.15414 16.6102 6.35414L8.61024 14.3541C8.50024 14.4541 8.37024 14.5041 8.24024 14.5041Z",
    fill: "#00BE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidPasswordCheck);
export default __webpack_public_path__ + "static/media/ValidPasswordCheck.a046b85243662a182b387add6d4e21aa.svg";
export { ForwardRef as ReactComponent };